export const PUBLIC_LOGO = '/Krinkels-logo.png';
export const HUSQVARNA_LOGO = '/Huqvarna-Logo.png';
export const KRESS_LOGO = '/Kress-Logo.png';

export const CURRENT_ANDROID_VERSION = '6.29';
export const CURRENT_ANDROID_VERSION_CODE = 16;

export const ENABLE_NATIVE_MOBILE_PUSH = String(
  process.env.REACT_APP_ENABLE_NATIVE_MOBILE_PUSH ?? process.env.REACT_APP_ENABLE_NATIVE_ANDROID_PUSH ?? 'true'
).toLowerCase() !== 'false';

export const DEFAULT_NOTIFICATION_PREFERENCES = Object.freeze({
  meldingen: true,
  garanties: true,
  bijzonderheden: true,
  onderdelen: true,
  robots: true,
});
